var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListofBooks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.98 20.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "List of Books") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-1080.18,356.55h0a1,1,0,0,0-.68.28,1,1,0,0,0-.28.69V372a1,1,0,0,0,1,1c2.25,0,6,.47,8.61,3.19V361a0.92,0.92,0,0,0-.13-0.49c-2.13-3.43-6.23-4-8.48-4h0Zm0,0",
    transform: "translate(1084.31 -356.55)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-1060.5,372V357.52a1,1,0,0,0-.28-0.69,1,1,0,0,0-.68-0.28h0c-2.25,0-6.35.53-8.48,4a0.92,0.92,0,0,0-.13.49v15.15c2.6-2.72,6.36-3.19,8.61-3.19a1,1,0,0,0,1-1h0Zm0,0",
    transform: "translate(1084.31 -356.55)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-1058.3,359.89h-0.7V372a2.47,2.47,0,0,1-2.46,2.46c-1.91,0-5,.38-7.27,2.48a23.23,23.23,0,0,1,10.22.2,1,1,0,0,0,.82-0.19,1,1,0,0,0,.36-0.75V360.86a1,1,0,0,0-1-1h0Zm0,0",
    transform: "translate(1084.31 -356.55)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-1082.65,372v-12.1h-0.7a1,1,0,0,0-1,1V376.2a1,1,0,0,0,.36.75,1,1,0,0,0,.82.19,23.24,23.24,0,0,1,10.22-.2c-2.23-2.11-5.37-2.48-7.27-2.48a2.47,2.47,0,0,1-2.46-2.46h0Zm0,0",
    transform: "translate(1084.31 -356.55)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListofBooks);
export default __webpack_public_path__ + "static/media/List of Books.4e0762ef.svg";
export { ForwardRef as ReactComponent };